import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { PlatformService } from 'buzzyears.ui';

export abstract class ApiService {

  constructor(protected http: HttpClient, protected platformService: PlatformService) {

  }

  get apiEndPoint(): string {
    return environment.appApiServer;
  }

  get requestOptions(): any {
    return this.platformService.requestOptions;
  }

  protected manageError(response: any): any {
    let errMsg = (response.message) ? response.message :
      response.status ? `${response.status} - ${response.statusText}` : 'Server error';

    const isJson = /json/.test(response.headers.get('Content-Type'));

    if (isJson) {
      const contents = typeof response.error === 'string' ? JSON.parse(response.error) : (response.error || {});

      if (contents.message) {
        errMsg = contents.message;
      }
    }

    console.error('Exports API Error: ' + errMsg);
    return Observable.throw(errMsg);
  }

  protected toUrl(...parts: string[]): string {
    return [ this.apiEndPoint, 'api', 'v1', ...parts ].join('/');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts